import { render, staticRenderFns } from "./SetEmailForm.vue?vue&type=template&id=d25ff2b0&lang=pug&"
import script from "./SetEmailForm.vue?vue&type=script&lang=js&"
export * from "./SetEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports